import { createContext } from "react";

export const UserEventDataBaseContext = createContext(null);